import React from 'react'
import PortalMessages from '../components/messages/PortalMessages'
import RecentActivities from '../components/messages/RecentActivities'

function Messages() {
    return (
        <div className="g-col-12 g-col-xl-3">
            <div className="border-start-xl border-theme-5 dark-border-dark-3 mb-n10 pb-10 p-0 ">
                <div className="ps-xl-5 ps-xxl-6 grid grid-cols-12 gap-6">
                    <PortalMessages />
                    <RecentActivities />
                </div>
            </div>
        </div>
    )
}

export default Messages